import ContactUsComponent from '../components/contact-us/contact-us'

const ContactUs = () => <ContactUsComponent />

export default ContactUs;